import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'


const settingsRouter: RouteConfig = {
  path: '/settings',
  component: Layout,
  redirect: '/settings/tenantSetting',
  name: '设置',
  meta: {
    title: '设置'
  },
  children: [
    {
      path: 'tenantSetting',
      name: '系统设置',
      component: () => import(/* webpackChunkName: "setting" */'@/views/admin/setting/tenantSetting.vue'),
      meta: {
        title: '系统设置'
      }
    },
    {
      path: 'splitOrderSetting',
      name: '分账配置',
      component: () => import(/* webpackChunkName: "setting" */'@/views/admin/setting/splitOrderSetting.vue'),
      meta: {
        title: '分账设置'
      }
    },
    {
      path: 'AliyunOssSetting',
      name: 'AliyunOssSetting',
      component: () => import(/* webpackChunkName: "setting" */'@/views/admin/setting/aliyunOssSetting.vue'),
      meta: {
        title: 'AliyunOss'
      }
    },
    {
      path: 'MailSetting',
      name: 'MailSetting',
      component: () => import(/* webpackChunkName: "setting" */'@/views/admin/setting/mailSetting.vue'),
      meta: {
        title: 'SMTP邮箱'
      }
    },
    {
      path:'wechatMessageSubscribe',
      name:'wechatMessageSubscribe',
      component:()=>import(/* webpackChunkName: "setting" */'@/views/messages/subscribe/config.vue'),
      meta:{
        title: '微信消息订阅'
      }
    },
    {
      path: 'UI',
      name: 'UI',
      component: () => import(/* webpackChunkName: "setting" */ '@/views/admin/ui.vue'),
      meta: {
        title: 'UI'
      }
    }
  ]
}

export default settingsRouter
